/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import SearchMode from '@linc-technologies/linced-common/enums/person-option-search-mode';

export default class SearchController extends Controller {
  queryParams = [
    'mode',
    'current',
    'preEnrolled',
    'former',
    'staff',
    'caregivers',
  ];

  @service
  session;

  @service
  personOptions;

  SearchMode = SearchMode;

  @alias('personOptions.searchMode')
  defaultMode;

  @tracked
  mode = SearchMode.GRID;

  // Status / Person Type filters (for list view).
  @tracked
  current = true;

  @tracked
  preEnrolled = false;
  @tracked
  former = false;
  @tracked
  staff = false;
  @tracked
  caregivers = false;

  @computed('session.school.jurisdiction', 'model.jurisdictionalIdField.label')
  get jurisdictionalIdLabel() {
    if (this.get('session.school.jurisdiction') === Jurisdiction.NZ_MOE) {
      // Return a shorter label than the full "National Student Number (NSN)".
      return 'NSN';
    } else if (
      this.get('session.school.jurisdiction') === Jurisdiction.AU_NSW
    ) {
      return 'SRN';
    } else {
      return 'Admission No.';
    }
  }

  init() {
    super.init(...arguments);
    // Use user's default search mode when initialising. The route's deactivate
    // hook will reset it when navigating away from the search route, but we
    // also need to set it here for the first search after a fresh load.
    this.mode = this.defaultMode;
  }

  @action
  setMode(mode) {
    this.mode = mode;
  }

  @action
  setDefaultMode() {
    this.personOptions.setSearchMode(this.mode);
  }

  reset() {
    this.mode = this.defaultMode;
    this.current = true;
    this.preEnrolled = false;
    this.former = false;
    this.staff = false;
    this.caregivers = false;
  }
}
